import React, { useRef, useState, useEffect } from "react";
// import { useForm, ValidationError } from "@formspree/react";
import "./booking.css";
import Tick_img from "../../assets/Images/tick2.png";

export default function Booking() {
  // Booking form -------------------------------
  // const [state, handleSubmit] = useForm("xleokljg");
  // const [formStatus, setFormStatus] = useState(null); // "success", "error", or null

  // if (state.succeeded) {
  //   setFormStatus("success");
  //   document.body.style.overflow = "hidden"; // Disable scrolling when showing message
  // }

  const formRef = useRef(null);
  const [formStatus, setFormStatus] = useState(null); // "success", "error", or null
  const [errorMessage, setErrorMessage] = useState("");

  // Success and error handling functions
  const handleSuccess = () => {
    if (formRef.current) formRef.current.reset(); // Reset form on success
    setFormStatus("success");
    document.body.style.overflow = "hidden"; // Disable scrolling when showing message
  };

  const handleError = () => {
    setFormStatus("error");
    setErrorMessage("Oops! There was a problem.");
    document.body.style.overflow = "hidden"; // Disable scrolling when showing message
  };

  // Submit handler
  const handleSubmit = (ev) => {
    ev.preventDefault();
    const form = formRef.current;
    const data = new FormData(form);

    // Perform the AJAX request
    ajax(form.method, form.action, data, handleSuccess, handleError);
  };

  // AJAX helper function
  const ajax = (method, url, data, successCallback, errorCallback) => {
    const xhr = new XMLHttpRequest();
    xhr.open(method, url);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        successCallback();
      } else {
        errorCallback();
      }
    };
    xhr.send(data);
  };

  // Clear status when component mounts or updates
  useEffect(() => {
    setFormStatus(null); // Reset form status on mount
  }, []);

  function handleFile(e) {
    console.log(e.target.value);
  }

  return (
    <div className="page">
      {/* <!-- Booking section --> */}
      <div className="row no-gutters row-layout">
        <div className="layout-booking">
          <div className="container-booking">
            <form
              onSubmit={handleSubmit}
              action="https://formspree.io/f/xleokljg"
              method="POST"
              id="my-form"
              enctype="multipart/form-data"
              ref={formRef}
            >
              {/* <!-- Peronal Details --> */}
              <h3 className="booking-title">
                <i className="fas fa-user form-icon"></i>Personal Details
              </h3>

              <div className="row">
                <div className="col-lg">
                  <div className="form-group">
                    <input
                      type="text"
                      name="Full Name"
                      id="fullName"
                      placeholder="Full Name*"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <input
                      type="tel"
                      name="Phone"
                      id="phone"
                      pattern="^\({0,1}((0|\+61)(2|4|3|7|8)){0,1}\){0,1}( |-){0,1}[0-9]{2}( |-){0,1}[0-9]{2}( |-){0,1}[0-9]{1}( |-){0,1}[0-9]{3}$"
                      placeholder="Phone*"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <input
                      type="email"
                      name="Email"
                      id="email"
                      placeholder="Email*"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <input
                      type="number"
                      name="Age"
                      id="age"
                      placeholder="Age*"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <select name="Gender" id="gender" required>
                      <option value="" disabled selected hidden>
                        Choose Gender
                      </option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                  </div>
                </div>
              </div>

              <hr className="spacer" />

              {/* <!-- Tattoo Concept --> */}
              <h3 className="booking-title">
                <i className="fas fa-edit form-icon"></i>Tattoo Concept
              </h3>

              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <select name="First Tattoo" id="firstTattoo" required>
                      <option value="" disabled selected hidden>
                        First Tattoo*
                      </option>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <select name="Colour Scheme" id="firstTattoo" required>
                      <option value="" disabled selected hidden>
                        Colour Scheme*
                      </option>
                      <option value="Black/Grey">Black/Grey</option>
                      <option value="Colour">Colour</option>
                      <option value="Artist Preference">
                        Artist Preference
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <input
                      type="text"
                      name="Body Placement"
                      id="bodyPlacement"
                      placeholder="Body Placement*"
                      required
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <input
                      type="text"
                      name="Planned Size"
                      id="plannedSize"
                      placeholder="Planned Size (cm)*"
                      required
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <select name="Tattoo Schedule" id="tattooSchedule" required>
                      <option value="" disabled selected hidden>
                        Tattoo Schedule*
                      </option>
                      <option value="ASAP">ASAP</option>
                      <option value="In 1 Month">In 1 Month</option>
                      <option value="In 3 Month">In 3 Month</option>
                      <option value="In 3-6 Month">In 3-6 Month</option>
                      <option value="In 6-12 Month">In 6-12 Month</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <select name="Choice of Artist" id="choceOfArtist" required>
                      <option value="" disabled selected hidden>
                        Choice of Artist*
                      </option>
                      <option value="Danny">Danny</option>
                      <option value="Alan">Alan</option>
                      <option value="Anto">Anto</option>
                      <option value="Lee">Lee</option>
                      <option value="Khang">Khang</option>
                      <option value="Tu">Tu</option>
                      <option value="Meg">Meg</option>
                      <option value="Chau">Chau</option>
                      <option value="Woojin">Woojin</option>
                      <option value="Yin">Yin</option>
                      <option value="Shayla">Shayla</option>
                      <option value="Devils">Devils</option>
                      <option value="Karl">Karl</option>
                      <option value="Nell">Nell</option>
                      <option value="Alex">Alex</option>
                      <option value="Not Sure">Not Sure</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg">
                  {/* <!-- Upload files/images --> */}
                  <div className="form-group">
                    <label for="referenceImage">
                      Tattoo Reference Image - Select 1 or more images...
                    </label>
                    <div className="drop-zone">
                      <input
                        type="file"
                        name="Image Attachment"
                        className="drop-zone__input"
                        id="image"
                        accept="image/png, image/jpeg"
                        multiple
                        onChange={handleFile}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg">
                  <div className="form-group">
                    <label for="shortDescription">
                      *Short Description of Tattoo
                    </label>
                    <textarea
                      name="Short Description of Tattoo"
                      id="message"
                      rows="4"
                      cols="40"
                      placeholder="Tattoo design ideas..."
                      required
                    ></textarea>
                  </div>
                </div>
              </div>

              <hr className="spacer" />

              <div className="row">
                <div className="col-lg">
                  <div className="form-group">
                    <label for="message">Additional Message</label>
                    <textarea
                      name="Message"
                      id="message"
                      rows="8"
                      cols="80"
                      placeholder=""
                    ></textarea>
                  </div>
                </div>
              </div>

              <button type="submit">SUBMIT</button>
            </form>
          </div>

          {/* Status Message Display */}
          {formStatus === "success" && (
            <div id="status" style={{ display: "block" }}>
              <div id="text">
                <img src={Tick_img} alt="Success" />
                <p>
                  Your booking form has been sent. <br></br>
                  We'll get back to you shortly.<br></br>
                </p>
                <a href="/">Return to home page</a>
              </div>
            </div>
          )}

          {formStatus === "error" && (
            <div id="status" style={{ display: "block" }}>
              <p>{errorMessage}</p>
            </div>
          )}

          <br />
        </div>
      </div>
    </div>
  );
}
